/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cart__row, .shipping-line__name').forEach(function(el){
    if(el.innerText.includes('Transporteurs partenaires')) {
      let priceEl = el.closest('.cart__row')?.querySelector('.cart__price') 
                    || el.querySelector('.shipping-line__price');
      if(priceEl && priceEl.innerText.trim() === 'Gratuit') {
        priceEl.innerText = 'Prix sur devis';
      }
    }
  });
});

// =============================================
// BARRE FRANCO DE PORT - LILI (Professionnels)
// =============================================

(function () {
  const SEUILS = {
    prisme: 2000,
    professionnel: 3000
  };

  let customerTags = null;
  let seuilActif = null;

  async function getCustomerTags() {
    if (customerTags !== null) return customerTags;
    const tags = (window.customerTags || []);
    customerTags = Array.isArray(tags)
      ? tags.map(t => t.toLowerCase().trim())
      : tags.toLowerCase().split(',').map(t => t.trim());
    return customerTags;
  }

  async function getCartTotal() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return cart.total_price / 100;
  }

  function getSeuil(tags) {
    if (tags.includes('prisme')) return SEUILS.prisme;
    if (tags.includes('professionnel')) return SEUILS.professionnel;
    return null;
  }

  function buildBarHTML(totalEuros, seuil) {
    const reste = Math.max(0, seuil - totalEuros);
    const pct = Math.min(100, (totalEuros / seuil) * 100);
    const atteint = reste === 0;
    const resteFormate = (reste / 2).toFixed(2).replace('.', ',');

    return `
      <div class="franco-bar" style="
        padding: 4px 16px 20px;
        border-bottom: 1px solid rgba(0,0,0,0.08);
        margin-bottom: 8px;
      ">
        <p style="
          font-size: 13px;
          margin: 0 0 7px;
          color: #333;
          text-align: center;
        ">
          ${atteint
            ? '🎉 <strong>Livraison offerte !</strong>'
            : `Plus que <strong>${resteFormate}€</strong> pour la livraison gratuite`
          }
        </p>
        <div style="
          background: #e0e0e0;
          border-radius: 999px;
          height: 5px;
          overflow: hidden;
        ">
          <div style="
            width: ${pct}%;
            background: #2d5a3d;
            height: 100%;
            border-radius: 999px;
            transition: width 0.4s ease;
          "></div>
        </div>
      </div>
    `;
  }

  function injectBar(html) {
    document.querySelectorAll('.franco-bar').forEach(el => el.remove());

    // Mini-cart drawer : avant la ligne Total
    const miniCartPriceLine = document.querySelector('.mini-cart__recap-price-line');
    if (miniCartPriceLine) {
      miniCartPriceLine.insertAdjacentHTML('beforebegin', html);
    }

    // Page panier : avant la ligne de prix Total dans le formulaire
    const cartPriceLine = document.querySelector('form.cart-recap .cart-recap__price-line');
    if (cartPriceLine) {
      cartPriceLine.insertAdjacentHTML('beforebegin', html);
    }
  }

  async function update() {
    const tags = await getCustomerTags();
    const seuil = getSeuil(tags);
    if (!seuil) return;

    seuilActif = seuil;
    const total = await getCartTotal();
    const html = buildBarHTML(total, seuil);
    injectBar(html);
  }

  // Lancement initial
  document.addEventListener('DOMContentLoaded', update);

  // Mise à jour quand le panier change (events Warehouse)
  document.documentElement.addEventListener('cart:updated', update);
  document.documentElement.addEventListener('cart:refresh', update);

  // Gère l'ouverture du mini-cart (rendu dynamique)
  const observer = new MutationObserver(() => {
    if (seuilActif && !document.querySelector('.franco-bar')) {
      update();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();